import {createSlice} from "@reduxjs/toolkit";


const initialState = {
    currencies: null
}

const compareByName = (a, b) =>
    (a?.name || "").localeCompare(b?.name || "", undefined, {sensitivity: "base"});

const sortCurrenciesByName = (currencies) =>
    [...(currencies || [])].sort(compareByName);

const currencySlice = createSlice({
    name: 'currency',
    initialState: initialState,
    reducers: {
        loadCurrenciesSuccess(state, action) {
            return {...state, currencies: sortCurrenciesByName(action.payload)}
        },
        updateCurrencySuccess(state, action) {
            const savedCurrency = action.payload;
            const existing = state.currencies || [];
            const withoutSaved = existing.filter((currency) => currency.id !== savedCurrency.id);
            const insertIndex = withoutSaved.findIndex((currency) => compareByName(currency, savedCurrency) > 0);
            const nextCurrencies = [...withoutSaved];
            if (insertIndex === -1) {
                nextCurrencies.push(savedCurrency);
            } else {
                nextCurrencies.splice(insertIndex, 0, savedCurrency);
            }
            return {...state, currencies: nextCurrencies}
        },
        // deleteCurrencySuccess(state, action) {
        //     const id = action.payload;
        //     const currencies = state.currencies.filter(currency => currency.id != id);
        //     return {...state, currencies: currencies}
        // }
    }
})

export const {loadCurrenciesSuccess, updateCurrencySuccess, deleteCurrencySuccess} = currencySlice.actions
export default currencySlice.reducer


export const fetchCurrencies = () => async (dispatch, getState) => {
    fetch('/api/currencies')
        .then((response) => {
            if (response.ok) {
                response.json().then(json =>
                    dispatch(loadCurrenciesSuccess(json)));
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const saveCurrency = (currency, onSuccess) => async (dispatch, getState) => {
    fetch('/api/currencies', {
        method: "PUT",
        body: JSON.stringify(currency),
        headers: {
            "Content-Type": "application/json",
        },
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    dispatch(updateCurrencySuccess(json));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const deleteCurrency = (currency, onSuccess) => async (dispatch, getState) => {
    fetch('/api/currencies?id=' + currency.id, {
        method: "DELETE",
        // body: JSON.stringify(currency),
    })
        .then((response) => {
            if (response.ok) {
                response.json().then(json => {
                    const savedCurrency = {...currency};
                    savedCurrency.state = "DELETED";
                    dispatch(updateCurrencySuccess(savedCurrency));
                    if(onSuccess) {
                        onSuccess();
                    }
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
}

export const selectCurrencies = (state) =>
    state.currencySlice.currencies;

export const selectCurrency = (state, currencyId) =>
    state.currencySlice.currencies
        ? state.currencySlice.currencies.find(currency => currency.id === currencyId || currency.id == currencyId)
        : undefined;